<template>
  <div>
    <Wrapper v-if="screenSize == 'Desktop'">
      <OverlayLayout
        :active="activeSidebar"
        :title="
          (activeSection && activeSection.type_name) ||
          elActiveID[1] ||
          elActiveID[0]
        "
        :navigate="elActiveID[0] == 'header' ? false : true"
        :close="() => elActive({ elementID: undefined })"
      >
        <template v-slot:body v-if="activeSection">
          <component
            v-if="elActiveID[0]"
            :is="getDynamicContent('ele' + elActiveID[0])"
          />
        </template>
      </OverlayLayout>
    </Wrapper>
    <Wrapper v-if="screenSize == 'Mobile'">
      <!-- <OverlayLayout
        :active="true"
        :title="titleDisplayMobile"
        :navigate="false"
        :closebtn = false
        :backbtn = false
      > -->
        <!-- <template v-slot:body v-if="true"> -->
        <component :is="getDynamicContent('elemobile')"/>
        <!-- </template> -->
      <!-- </OverlayLayout> -->
    </Wrapper>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper } from "./Overlay.styled";
import Title from "./Title/Title";

const Content = {
  Default: () =>
    import(/* webpackChunkName: "SidebarDefault" */ "./Default/Default"),
  eleheader: () =>
    import(/* webpackChunkName: "SidebarHeader" */ "./Header/Header"),
  // eleheaderMobile: () =>
  //   import(/* webpackChunkName: "SidebarHeader" */ "./Header/HeaderMobile"),
  // elesection: () =>
  // import(/* webpackChunkName: "SidebarSection" */ "./Section/Section"),
  elecomponent: () =>
    import(/* webpackChunkName: "SidebarComponent" */ "./Component/Component"),
  elefooter: () =>
    import(/* webpackChunkName: "SidebarFooter" */ "./Footer/Footer"),
  elewebsite_theme: () =>
    import(
      /* webpackChunkName: "Sidebarappearance" */ "./Appearance/Appearance"
    ),
  elemobile: () =>
    import(
      /* webpackChunkName: "SidebarMobile" */ "./MobileSidebar/MobileSidebar"
    ),
};

const componentsKey = Object.keys(Content);

export default {
  components: {
    Wrapper,
    Title,

    ...Content,
  },

  data() {
    return {
      // visibleDesign: false,
      visibleLayout: false,
      visibleContent: true,
      visibleTitle: false,
    };
  },
  watch: {
    elActiveID(nextVal) {
      if (nextVal[0]) {
        this.visibleContent = true;
      }
    },
  },
  computed: {
    ...mapGetters({
      elActiveID: "design/component/elActiveID",
      activeSection: "design/component/activeSection",
      screenSize: "screenSize",
      languageEngine: "design/userPreference/languageEngine",
    }),
    activeSidebar() {
      return this.elActiveID.length > 0;
    },
    titleDisplayMobile() {
      return this.$t('engine.common.settings.mobile', this.languageEngine)
    }
  },
  methods: {
    elActive({ elementID }) {
      this.$store.dispatch("design/component/elActive", { elementID });
      if (elementID) this.scrollToId(elementID);
    },
    getDynamicContent(key) {
      if (componentsKey.indexOf(key) > -1) {
        return key;
      } else {
        return "Default";
      }
    },
  },
};
</script>